import { render, staticRenderFns } from "./SimpleChart.vue?vue&type=template&id=58babbac&"
import script from "./SimpleChart.vue?vue&type=script&lang=js&"
export * from "./SimpleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports